module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Heavy.c39450c3.ttf";